import EmbeddedCardLayout from '../../../components/embedded/CardLayout';
import EmbeddedQrCodeCard from '../../../components/embedded/QrCodeCard';
import EmbeddedCaption from '../../../components/embedded/Caption';
import { useAnotherApp, useEmbeddedCopy } from '../../../hooks/useEmbeddedCopy';

/** The request expired while the QR code was on screen: it fades in place and is the Refresh button. */
export default function EmbeddedExpiredQrScreen({
  onRefresh,
  onBack,
}: {
  onRefresh: () => void;
  onBack?: () => void;
}) {
  const { t } = useEmbeddedCopy();
  return (
    <EmbeddedCardLayout secondary={useAnotherApp(onBack)}>
      <EmbeddedQrCodeCard
        data=""
        label={t('embedded.qr.expired')}
        expired={{ label: t('embedded.qr.refresh'), onRefresh }}
      />
      <EmbeddedCaption text={t('embedded.qr.expired')} bold="" />
    </EmbeddedCardLayout>
  );
}
